import React, { createContext, useState } from 'react'

export const ConsentContext = createContext(false)

export const ConsentProvider = ({ children }) => {
    const [hideConsentModal, setHideConsentModal] = useState(false)
    const [showFooterConsentLink, setShowFooterConsentLink] = useState(false)

    return (
        <ConsentContext.Provider value={{ hideConsentModal, setHideConsentModal, showFooterConsentLink, setShowFooterConsentLink }}>
            {children}
        </ConsentContext.Provider>
    )
}

export default ConsentContext